import { useMemo, useState } from "react";
import moment from "moment-timezone";

import { t } from "@repo/transifex";

export const useWeekFilter = () => {
  const [week, setWeek] = useState(moment().isoWeek());

  return useMemo(() => {
    const isCurrent = week === moment().isoWeek();

    const start = moment().isoWeek(week).startOf("isoWeek");
    const startFormat = start.format("MMM DD, YYYY");

    const end = moment().isoWeek(week).endOf("isoWeek");
    const endFormat = end.format("MMM DD, YYYY");

    return {
      label: isCurrent ? t("This week") : `${startFormat} - ${endFormat}`,
      start: start.unix(),
      end: end.unix(),
      handleNext: () => {
        setWeek((prev) => prev + 1);
      },
      handlePrev: () => {
        setWeek((prev) => prev - 1);
      }
    };
  }, [week]);
};

/**
 * The offset is relative because the state seeds before `timezone` arrives. An
 * absolute weekday would come from the device and name the wrong day.
 */
export const useDayFilter = (timezone?: string) => {
  const [dayOffset, setDayOffset] = useState(0);

  return useMemo(() => {
    const day = timezone ? moment.tz(timezone) : moment();
    day.add(dayOffset, "day");

    return {
      label: dayOffset === 0 ? t("Today") : day.format("MMM DD, YYYY"),
      start: day.clone().startOf("day").unix(),
      end: day.clone().endOf("day").unix(),
      // Offset 0 is the till's today, so there is never a next day to show.
      canGoNext: dayOffset < 0,
      handleNext: () => {
        setDayOffset((prev) => prev + 1);
      },
      handlePrev: () => {
        setDayOffset((prev) => prev - 1);
      }
    };
  }, [dayOffset, timezone]);
};
